import Grid from "@mui/material/Grid";
import Skeleton from '@mui/material/Skeleton';

import useCheckHistory from "../../hooks/useCheckHistory";
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import { BackArrow } from "../../iconRef/recipePageIcons";
import { EventLogsEnum } from "../../utils/events";
import RecipeBannerSkeletonImage from "../../utils/images/recipeBannerSkeleton.webp";
import styles from './recipePageSkeleton.module.css';

const RecipePageSkeleton = () => {
    const { logRecipeEdit } = useLogRecipeEdit();
    const goBackOrRedirect = useCheckHistory();

    const handleSkeletonBackClick = () => {
        goBackOrRedirect('/');
        logRecipeEdit(EventLogsEnum.APP_BACK_PRESSED);
    }

    return (
        <Grid className={styles.wrapper} id="skeleton-wrapper">
            <Grid
                className={styles.banner_skeleton}
                style={{
                    background: `linear-gradient(rgba(0, 0, 0, 0.829), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.842)), url(${RecipeBannerSkeletonImage})`
                }}
            >
                <Grid className={styles.banner_header}>
                    <Grid onClick={handleSkeletonBackClick}><BackArrow /></Grid>
                </Grid>
            </Grid>
            <Grid className={styles.banner_text}>
                <Skeleton className={styles.banner_text_heading} variant="rectangular" />
                <Skeleton className={styles.banner_text_subtitle} variant="rectangular" />
            </Grid>
            <Grid className={styles.recipe_data_container} id="skeleton-data-container">
                <Grid className={styles.recipe_data_text} id="skeleton-data-clock">
                    <Skeleton className={styles.skeleton_border} height={32} id="nutrition-per-serving-skeleton"
                        variant="rectangular" width={107} />
                    <Skeleton className={styles.skeleton_border} height={32} id="nutrition-data-skeleton"
                        variant="rectangular" width={32} />
                </Grid>
                <Grid className={styles.left_flex} id="allegens-header-skeleton">
                    <Skeleton className={styles.skeleton_border} height={24} id="serving-size-skeleton"
                        variant="rectangular" width={24} />
                    <Skeleton className={styles.skeleton_border} height={24} id="serving-qnt-skeleton"
                        variant="rectangular" width={151} />
                </Grid>
                <Skeleton className={styles.skeleton_border} height={63} id="nutrition-containere-skeleton"
                    variant="rectangular" />
                <Grid className={styles.left_flex}>
                    <Skeleton className={styles.skeleton_border} height={24} variant="rectangular"
                        width={24} />
                    <Skeleton className={styles.skeleton_border} height={24} variant="rectangular"
                        width={140} />
                </Grid>
                <Grid className={styles.recipe_data_text}>
                    <Grid className={styles.left_flex}>
                        <Skeleton className={styles.skeleton_border} height={24} variant="rectangular"
                            width={24} />
                        <Skeleton className={styles.skeleton_border} height={24} variant="rectangular"
                            width={88} />
                    </Grid>
                    <Skeleton className={styles.skeleton_border} height={32} variant="rectangular"
                        width={97} />
                </Grid>
                <Grid className={styles.left_flex}>
                    <Skeleton className={styles.skeleton_border} height={24} variant="rectangular"
                        width={24} />
                    <Skeleton className={styles.skeleton_border} height={24} variant="rectangular"
                        width={83} />
                </Grid>
                <Skeleton className={styles.skeleton_border} height={71} variant="rectangular" />
                <Skeleton className={styles.skeleton_border} height={71} variant="rectangular" />
                <Skeleton className={styles.skeleton_border} height={71} variant="rectangular" />
            </Grid>
        </Grid>
    );
}

export default RecipePageSkeleton;
